<script>
const DialogId1 = resolve => {
  import('./DialogId1.vue').then(module => resolve(module))
}
const DialogId2 = resolve => {
  import('./DialogId2.vue').then(module => resolve(module))
}
const DialogId3 = resolve => {
  import('./DialogId3.vue').then(module => resolve(module))
}
const DialogId4 = resolve => {
  import('./DialogId4.vue').then(module => resolve(module))
}
const DialogId5 = resolve => {
  import('./DialogId5.vue').then(module => resolve(module))
}
const DialogId6 = resolve => {
  import('./DialogId6.vue').then(module => resolve(module))
}
const DialogId7 = resolve => {
  import('./DialogId7.vue').then(module => resolve(module))
}
const DialogId8 = resolve => {
  import('./DialogId8.vue').then(module => resolve(module))
}
const DialogId9 = resolve => {
  import('./DialogId9.vue').then(module => resolve(module))
}
const DialogId10 = resolve => {
  import('./DialogId10.vue').then(module => resolve(module))
}
const DialogId11 = resolve => {
  import('./DialogId11.vue').then(module => resolve(module))
}
const DialogId12 = resolve => {
  import('./DialogId12.vue').then(module => resolve(module))
}
const DialogId13 = resolve => {
  import('./DialogId13.vue').then(module => resolve(module))
}
const DialogId14 = resolve => {
  import('./DialogId14.vue').then(module => resolve(module))
}
const DialogId15 = resolve => {
  import('./DialogId15.vue').then(module => resolve(module))
}

import { mapGetters } from 'vuex'

export default {
  name: 'DialogModules',
  components: {
    DialogId1, DialogId2, DialogId3, DialogId4, DialogId5, DialogId6, DialogId7, DialogId8, DialogId9, DialogId10,
    DialogId11, DialogId12, DialogId13, DialogId14, DialogId15 },
  props: {
    currentModule: {
      type: Object,
      default: () => {}
    },
    currentModuleItemDataId: {
      type: Number,
      default: 0
    },
    currentModuleItemDataHeadline: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      currentModuleIdGetter: 'config/getCurrentModuleId',
      componentConfigure: 'subpageConfigure/getComponentConfigure',
      componentDataConfigure: 'subpageConfigure/getComponentDataConfigure'
    }),
    currentModuleId() {
      return this.currentModuleIdGetter
    },
    moduleConfigure() {
      return this.componentConfigure?.id ? this.componentConfigure : this.currentModule
    },
    moduleItemDataId() {
      return this.componentDataConfigure?.id ? this.componentDataConfigure.id : this.currentModuleItemDataId
    },
    moduleItemDataHeadline() {
      /* dialogId为11的 */
      if ([7, 25].includes(this.componentConfigure?.id)) {
        return this.componentConfigure.subtitle
      } else return this.componentDataConfigure?.headline ? this.componentDataConfigure.headline : this.currentModuleItemDataHeadline
    }
  },
  methods: {
    modulesFilter(currentModule) {
      const { id = 0, typeid = 0 } = this.moduleConfigure
      let dialog_module_name = ''
      const whiteList = [2, 3, 10, 22, 23, 29, 42, 43, 44, 45, 46, 49, 54]
      if (whiteList.includes(Number(id))) {
        switch (Number(typeid)) {
          case 1: dialog_module_name = 'dialogId2'
            break
          case 2: dialog_module_name = 'dialogId4'
            break
        }
        // dialog_module_name = Number(currentModule.typeid) === 1 ? 'dialogId2' : 'dialogId4' // 1-图文 2-照片 3-文件
      } else if (id === 32 || this.currentModuleId === 32_1) {
        dialog_module_name = this.currentModuleId === 32_1 ? 'dialogId14' : 'dialogId7'
      } else {
        const modulesObj = {
          dialogId1: [5, 27, 48, 53, 59],
          dialogId2: [],
          dialogId3: [28, 58, 64],
          dialogId4: [11, 12, 14, 18, 19, 50, 52],
          dialogId5: [16, 17, 47],
          dialogId6: [15, 61, 66],
          dialogId7: [1, 4, 32, 62],
          dialogId8: [8],
          dialogId9: [13, 60],
          dialogId10: [9, 30, 51, 63],
          dialogId11: [7, 25],
          dialogId12: [6, 24, 21, 26, 65],
          dialogId13: [31],
          dialogId14: [32_1], // 32
          dialogId15: [55]
        }
        for (const key in modulesObj) {
          if (modulesObj[key].includes(Number(id))) dialog_module_name = key
        }
      }
      return dialog_module_name
    }
  }
}
</script>

<template>
  <div>
    <component
      :is="modulesFilter(currentModule)"
      :current-module="moduleConfigure"
      :current-module-item-data-id="moduleItemDataId"
      :current-module-item-data-headline="moduleItemDataHeadline"
    />
  </div>
</template>

<style lang="scss" scoped>
</style>
